
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developers/try-it-yourself",
      function () {
        return require("private-next-pages/developers/try-it-yourself.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developers/try-it-yourself"])
      });
    }
  